"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Results_class_1 = __importDefault(require("./Results.class"));
exports.default = (0, vue_1.defineComponent)({
    setup: () => {
        const component = new Results_class_1.default();
        (0, vue_1.onMounted)(component.mounted.bind(component));
        return {
            userName: component.userName,
            coverImageUrl: component.coverImageUrl,
            portalURL: component.portalURL,
            searchURL: component.searchURL,
            topResults: component.topResults,
            firstResult: component.firstResult,
        };
    }
});
